import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  text-align: center;
  color: #999;
`;

const Icon = styled.div`
  font-size: 64px;
  color: #ddd;
  margin-bottom: 16px;
  
  i {
    font-size: 64px;
  }
`;

const Title = styled.h3`
  font-size: 18px;
  font-weight: 600;
  color: #666;
  margin-bottom: 8px;
`;

const Description = styled.p`
  font-size: 14px;
  color: #999;
  max-width: 400px;
  line-height: 1.6;
  margin: 0;
`;

const EmptyState = ({icon = 'mdi-information-outline', title, description}) => (
  <Container>
    <Icon>
      <i className={`mdi ${icon}`} />
    </Icon>
    {title && <Title>{title}</Title>}
    {description && <Description>{description}</Description>}
  </Container>
);

EmptyState.propTypes = {
  icon: PropTypes.string,
  title: PropTypes.string,
  description: PropTypes.string,
};

export default EmptyState;

